export default "__VITE_ASSET__DggBZtUc__"